import * as React from 'react';
import Common from '../../utilities/common';
import $ from "jquery";
import { Card, CardContent, Stack, Typography } from '@mui/material';
import FunctionsOutlinedIcon from '@mui/icons-material/FunctionsOutlined';
import ReactInterval from 'react-interval';

export interface IIpsTotalProps {
    title: string;
    icon?: string | JSX.Element | JSX.Element[];
    total: number;
}

export default class IpsTotal extends React.Component<IIpsTotalProps, {}> {
    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <Card>
                    <CardContent>
                        {
                            this.props.icon == null && (
                                <React.Fragment>
                                    <Typography gutterBottom variant="body2" color='text.secondary' component="div">
                                    {
                                        this.props.title
                                    }
                                    </Typography>
                                    {
                                        this.props.total > -1 && (
                                            <Typography variant='h5' color="text.secondary" gutterBottom textAlign='center'>
                                                {
                                                    this.props.total.toLocaleString()
                                                }
                                            </Typography>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                        {
                            this.props.icon != null && (
                                <React.Fragment>
                                    <Typography gutterBottom variant="body2" color='text.secondary' component="div">
                                    {
                                        this.props.title
                                    }
                                    </Typography>
                                    <Stack direction='row' spacing={3}>
                                    {
                                        this.props.icon
                                    }
                                    {
                                        this.props.total > -1 && (
                                            <Typography variant='h4' color="text.secondary" gutterBottom textAlign='center'>
                                                {
                                                    this.props.total.toLocaleString()
                                                }
                                            </Typography>
                                        )
                                    }
                                    </Stack>
                                </React.Fragment>
                            )
                        }
                    </CardContent>
                </Card>
            </React.Fragment>
        )
    }
}